'use strict';exports.__esModule = true;var _ = require('./1.png');var _2 = _interopRequireDefault(_);
var _3 = require('./2.png');var _4 = _interopRequireDefault(_3);
var _5 = require('./3.png');var _6 = _interopRequireDefault(_5);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  banner1: _2.default,
  banner2: _4.default,
  banner3: _6.default };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ListBanner/banners/index.js
// module id = 2716
// module chunks = 0